import { onReady } from './utils/on-ready';
import { loopThroughElements } from './utils/loop-through-elements';
import { getFragment } from './utils/fragment';

declare global {
    interface HTMLElementTagNameMap {
        'md-tab-bar': HTMLMdTabBarElement;
        'md-tab': HTMLMdTabElement;
    }

    interface HTMLMdTabBarElement extends HTMLElement {
        selected: number;
        addEventListener(
            type: 'selected',
            listener: (this: HTMLMdTabBarElement, ev: CustomEvent<{ index: number }>) => any,
            options?: boolean | AddEventListenerOptions
        ): void;
        getIndexOfTabById(id: string): number;
    }

    interface HTMLMdTabElement extends HTMLElement {
        id: string;
    }
}

export class TabPager {
    constructor() {
        onReady(this.initialize);
    }

    initialize = (): void => {
        const tabBarElement = document.querySelector('md-tab-bar.mdc-tab-bar--pager') as HTMLMdTabBarElement | null;
        const defaultTab = tabBarElement ? Number(tabBarElement.dataset.defaultTab) : 0;

        if (tabBarElement) {
            const contentParentId = tabBarElement.dataset.for;
            const contentParent = contentParentId ? document.getElementById(contentParentId) : null;

            if (contentParent) {
                tabBarElement.addEventListener('selected', (e: CustomEvent<{ index: number }>) => {
                    this.onTabChange(e, contentParent);
                });

                if (typeof defaultTab === 'number') {
                    tabBarElement.selected = defaultTab;
                }
            }
        }

        this.goToFragment(defaultTab || 0);

        window.addEventListener('hashchange', () => this.goToFragment(), false);
    };

    onTabChange = (event: CustomEvent<{ index: number }>, contentParent: HTMLElement): void => {
        if (contentParent) {
            const contentEls = contentParent.querySelectorAll('.content');

            loopThroughElements(
                contentParent.getElementsByClassName('content--active'),
                (el) => el.classList.remove('content--active')
            );

            const newActiveContent = contentEls[event.detail.index] as HTMLElement;
            if (newActiveContent) {
                newActiveContent.classList.add('content--active');
            }
        }
    };

    goToFragment = (defaultIndex: number = 0): void => {
        const fragment = getFragment();
        const tabBarElement = document.querySelector('md-tab-bar.mdc-tab-bar--pager') as HTMLMdTabBarElement | null;

        if (tabBarElement) {
            if (fragment) {
                const tabIndex = tabBarElement.getIndexOfTabById(fragment);
                if (tabIndex > -1) {
                    tabBarElement.selected = tabIndex;
                    window.scrollTo(0, 0);
                    return;
                }
            }
            tabBarElement.selected = defaultIndex;
        }
    };
}
